<template>
	<main id="container" class="vx-row justify-center">
		<div class="vx-col w-full md:w-2/3 lg:w-1/2 xl:w-1/3">
			<div class="flex items-center mb-4" @click="$router.push(`/profile`)" style="cursor: pointer;">
				<feather-icon icon="ChevronLeftIcon" svgClasses="text-primary mr-4"></feather-icon>
				<strong>Kembali</strong>
			</div>
			<vx-card>
				<header class="flex justify-center flex-col mb-8">
					<img :src="profile.file ? profile.file : defaultProfile" alt="" class="rounded-full mx-auto mb-4 w-32 mb-2" />
					<div class="flex justify-center">
						<vs-button type="gradient" class="rounded-none w-1/4 text-center" size="small">{{ profile.level ? profile.level.name : '-' }}</vs-button>	
					</div>
				</header>
				<section>
					<ul>
						<li
						    v-for="(item, i) in myFeatures"
						    :key="i"
						    style="border-bottom: 1px solid #ccc"
						    class="py-4"
						>
							<router-link :to="item.url" class="w-full block">{{item.label}}</router-link>
						</li>
					</ul>
				</section>
			</vx-card>
		</div>
	</main>
</template>
<script>
import { mapState } from 'vuex'
import defaultProfile from '@/assets/images/profile/default.jpg'
import { roleFeatures } from '@/assets/utils/user_roles'

export default {
  data: () => ({
    data: null,
    myFeatures: []
  }),
  methods: {
    getFeature () {
      this.data = this.profile
      // get my level
      if (this.data.level) {
        const myLevel = this.data.level.slug

        // Find if my level has feature
        Object.keys(roleFeatures).forEach(role => {
          if (myLevel === role) { // if muzakki == muzakki || has feature
            // get feature
            this.myFeatures = roleFeatures[myLevel]							
          }
        })
      }
    }
  },
  computed: {
    ...mapState('auth', ['profile']),
    defaultProfile () {
      return defaultProfile
    }
  },
  created () {
    this.getFeature()
  }
}
</script>